
  import { ComputedRef, PropType, defineComponent, computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  import StatCard from '@/components/Common/StatCard.vue'
  import { IUserProfile } from '@/types/user'

  export default defineComponent({
    name: 'UserStatsCards',
    components: {
      StatCard,
    },
    props: {
      user: {
        type: Object as PropType<IUserProfile>,
        required: true,
      },
    },
    setup(props) {
      const { t } = useI18n()
      const total_duration: ComputedRef<string> = computed(
        () => props.user.total_duration
      )

      function get_duration(total_duration: ComputedRef<string>) {
        const duration = total_duration.value.match(/day/g)
          ? total_duration.value.split(', ')[1]
          : total_duration.value
        return {
          days: total_duration.value.match(/day/g)
            ? `${total_duration.value.split(' ')[0]} ${
                total_duration.value.match(/days/g)
                  ? t('common.DAY', 2)
                  : t('common.DAY', 1)
              }`
            : `0 ${t('common.DAY', 2)},`,
          duration: `${duration.split(':')[0]}h ${duration.split(':')[1]}min`,
        }
      }

      return { total_duration: computed(() => get_duration(total_duration)) }
    },
  })
